import React, { useEffect, useState } from "react";
import {
  DateInput,
  RadioInput,
  SelectInput,
  TextAreaInput,
  TextInput,
} from "../../../components/common/ui/Inputs";
import { useDispatch, useSelector } from "react-redux";
import { eventsActions } from "../../../_store/events.slice";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import ToggleSwitch from "../../../components/common/ui/Inputs/ToggleSwitch";
import MultiSelectDropdown from "../../../components/common/ui/Inputs/MultiSelectDropdown";
import Button from "../../../components/common/ui/Button";
import calenderSchema from "../../../validation/Admin/CalenderSchema";
import { history } from "../../../_helpers";
import { useLocation } from "react-router-dom";
import CustomLoader from "../../../components/common/ui/Loader";

function AddOrEditPublicEvents() {
  const dispatch = useDispatch();
  const location = useLocation();
  const isEditMode = location?.state?.publicEventRow?._id ? true : false;

  const eventID = location?.state?.publicEventRow?._id;

  const {
    eventType,
    locationType,
    numberSet,
    monthFrequencySet,
    periodSet,
    daySet,
  } = useSelector((x) => x?.dropDown);
  const { eventForm, getPublicCommitteeEventDetailsResponse, loading } =
    useSelector((x) => x?.events);

  const [errorMessage, setErrorMessage] = useState({});
  // const [isEditMode, setIsEditMode] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&status=${true}`,
  );

  useEffect(() => {
    dispatch(eventsActions?.resetForm());
    if (!isEditMode || !eventID) return;
    debugger;
    // dispatch(eventsActions?.getCommitteeEventDetails(eventID))
    dispatch(eventsActions?.getCommitteeEventDetailsPublic(eventID))
      .then((result) => {
        if (result?.payload?.status === 1) {
          const response = { ...result?.payload?.data?.event };
          response["start"] = response?.start ? new Date(response?.start) : "";
          response["end"] = response?.end ? new Date(response?.end) : "";
          response["eventType"] = "single";
          dispatch(eventsActions?.updateForm(response));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  }, [eventID]);

  // console.log("eventForm", eventForm);

  // const isSameDay = (start, end) => {
  //   return (
  //     start &&
  //     end &&
  //     start?.getFullYear() === end?.getFullYear() &&
  //     start?.getMonth() === end?.getMonth() &&
  //     start?.getDate() === end?.getDate()
  //   );
  // };

  const isSameDay = (start, end) => {
    if (!start || !end) return false;

    const startDate = start instanceof Date ? start : new Date(start);
    const endDate = end instanceof Date ? end : new Date(end);

    return (
      startDate?.getFullYear() === endDate?.getFullYear() &&
      startDate?.getMonth() === endDate?.getMonth() &&
      startDate?.getDate() === endDate?.getDate()
    );
  };

  const handleChange = (e, select) => {
    const form = { ...eventForm };
    form["publicEvent"] = true;
    form["committee"] = null;
    if (select) {
      form[select] = e;
      dispatch(eventsActions?.updateForm(form));
      return;
    }
    const { name, value } = e?.target;
    form[name] = value;
    if (name === "location") {
      form["url"] = "";
      form["address"] = "";
    }
    dispatch(eventsActions?.updateForm(form));
  };

  const handleAllDay = (e) => {
    const form = { ...eventForm };
    form["publicEvent"] = true;
    form["committee"] = null;
    const { name, checked } = e?.target;
    form[name] = checked ? 1 : 0;

    dispatch(eventsActions?.updateForm(form));
  };

  const handleSelectBoxChanges = (e, select) => {
    const form = { ...eventForm };
    form["publicEvent"] = true;
    form["committee"] = null;
    form[select] =
      e?.value === undefined && select === "repeatEvery"
        ? 1
        : e?.value === undefined && select === "period"
          ? ""
          : e?.value;
    dispatch(eventsActions?.updateForm(form));
    return;
  };

  function formatLocalDate(date) {
    const pad = (n) => (n < 10 ? "0" + n : n);

    return (
      date?.getFullYear() +
      "-" +
      pad(date?.getMonth() + 1) +
      "-" +
      pad(date?.getDate()) +
      "T" +
      pad(date?.getHours()) +
      ":" +
      pad(date?.getMinutes()) +
      ":" +
      pad(date?.getSeconds())
    );
  }

  const handleSubmit = (e) => {
    debugger;
    e?.preventDefault();
    setErrorMessage({});
    setIsPending(true);
    const form = { ...eventForm };
    form["publicEvent"] = true;
    form["committee"] = null;
    form["start"] = form?.start ? formatLocalDate(new Date(form["start"])) : "";
    form["end"] = form?.end ? formatLocalDate(new Date(form["end"])) : "";
    // dispatch(eventsActions?.updateForm(form));
    const { error } = calenderSchema(form);
    if (error?.details) {
      setIsPending(false);
      const errors = {};
      error.details.forEach((err) => {
        const key = err.path[0];
        if (!errors[key]) {
          errors[key] = err.message;
        }
      });
      setErrorMessage(errors);
      return;
    }

    const request = isEditMode
      ? // ? dispatch(eventsActions?.updateEvent(form))
        dispatch(eventsActions?.updateEventPublic(form))
      : eventForm?.eventType === "single"
        ? dispatch(eventsActions?.createEvent(form))
        : dispatch(eventsActions?.createRecurrenceEvent(form));
    request
      .then((result) => {
        if (result?.payload?.status === 1) {
          setIsPending(false);
          showToastNotification(result?.payload?.message, "success");

          const searchParams = `${apiParams}`;
          dispatch(eventsActions?.getPublicSingleEventList(searchParams));
          dispatch(eventsActions?.getPublicRecurrenceEventList(searchParams));

          dispatch(eventsActions?.resetForm({}));
          setTimeout(() => {
            history?.navigate("/Admin/PublicEvents");
          }, 3000);
        } else {
          showToastNotification(result?.error?.message, "error");
          setIsPending(false);
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create member", "error");
        setIsPending(false);
      });
  };

  const handleWeekDayChanges = (e, select) => {
    const form = { ...eventForm };
    form["publicEvent"] = true;
    form["committee"] = null;
    const selectedIds = e?.map((item) => item.value) || [];
    form[select] = selectedIds;
    dispatch(eventsActions?.updateForm(form));
  };

  const handleMonthDayChanges = (e, select) => {
    const form = { ...eventForm };
    form["publicEvent"] = true;
    form["committee"] = null;
    const selectedIds = e?.map((item) => item.value) || [];
    form[select] = selectedIds;
    dispatch(eventsActions?.updateForm(form));
  };

  const handleReset = () => {
    debugger;
    setErrorMessage({});
    if (isEditMode) {
      const row = { ...getPublicCommitteeEventDetailsResponse?.data?.event };
      row["start"] = new Date(row["start"]);
      row["end"] = new Date(row["end"]);
      dispatch(eventsActions?.updateForm(row));
    } else {
      dispatch(eventsActions?.resetForm({}));
    }
  };

  if (loading) return <CustomLoader />;

  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <h1 className="header-color">Public Events</h1>
        <Button
          label="Back"
          status="reset"
          onClick={() => {
            history?.navigate("/Admin/PublicEvents", {
              tate: { committeeID: 0 },
            });
          }}
        />
      </div>

      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom integrate-card-header">
          {isEditMode ? "Edit" : "Create"} Event
        </h1>

        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
          className="p-3 row mb-4"
        >
          <div className="col-md-12 mb-2">
            <RadioInput
              name="eventType"
              id="eventType"
              label="Event"
              options={eventType}
              selectedValue={eventForm?.eventType}
              handleChange={(e) => {
                handleChange(e);
              }}
              errorMessage={errorMessage}
              disabled={isEditMode}
            />
          </div>
          <div className="col-md-4">
            <TextInput
              name="title"
              id="title"
              label="Title"
              placeholder="Title"
              handleChange={(e) => {
                handleChange(e);
              }}
              value={eventForm?.title}
              required
              maxLength={150}
              errorMessage={errorMessage}
            />
          </div>

          <div className="col-md-4">
            <DateInput
              name="start"
              id="start"
              handleChange={(e) => {
                handleChange(e, "start");
              }}
              placeholder="Select Date"
              showTimeSelect={true}
              label={"Start Date & Time"}
              value={eventForm?.start}
              isClearable={eventForm?.start}
              errorMessage={errorMessage}
              required
              minDate={new Date()}
              // minTime={new Date()}
              maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
              minTime={
                isSameDay(eventForm?.start || new Date(), new Date())
                  ? new Date() // restrict to current time if today
                  : new Date(new Date().setHours(0, 0, 0, 0)) // allow from 00:00 for future dates
              }
            />
          </div>
          <div className="col-md-4">
            <DateInput
              name="end"
              id="end"
              value={eventForm?.end}
              handleChange={(e) => {
                handleChange(e, "end");
              }}
              placeholder="Select Date"
              showTimeSelect={true}
              label={"End Date & Time"}
              isClearable={eventForm?.end}
              errorMessage={errorMessage}
              minDate={eventForm?.start}
              minTime={
                !isSameDay(
                  eventForm?.start,
                  eventForm?.end === "" ? eventForm?.start : eventForm?.end,
                )
                  ? new Date(new Date().setHours(0, 0, 0, 0))
                  : new Date(new Date(eventForm?.start).getTime() + 1 * 60000)
              }
              maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
              required
            />
          </div>

          {eventForm?.eventType === "recurrence" && (
            <div className="col-md-4">
              <label className="form-label col-form-label  w-100 fs-5 form-label-custom-visible">
                All Day
              </label>
              <ToggleSwitch
                name={`allDay`}
                id={`allDay`}
                checked={eventForm.allDay}
                value={eventForm.allDay === 1 ? true : false}
                handleClick={(e) => handleAllDay(e)}
              />
            </div>
          )}

          {eventForm?.eventType === "recurrence" && eventForm?.allDay === 0 && (
            <>
              <div className="col-md-4">
                <SelectInput
                  options={numberSet}
                  name="repeatEvery"
                  id="repeatEvery"
                  label="Repeat Every"
                  handleChange={(e) => {
                    handleSelectBoxChanges(e, "repeatEvery");
                  }}
                  value={eventForm?.repeatEvery}
                />
              </div>

              <div className="col-md-4">
                <SelectInput
                  options={periodSet}
                  name="period"
                  id="period"
                  label="Period"
                  handleChange={(e) => {
                    handleSelectBoxChanges(e, "period");
                  }}
                  value={eventForm?.period}
                />
              </div>

              {eventForm?.period === "week" && (
                <div className="col-md-4 mt-4   ">
                  <MultiSelectDropdown
                    options={daySet}
                    displayValue="label"
                    handleChange={(e) =>
                      handleWeekDayChanges(e, "weekDaySelected")
                    }
                    placeholder="Choose Day(s)"
                    required
                    label="Choose Day(s)"
                    errorMessage={errorMessage}
                    selectedValue={daySet?.filter((option) =>
                      eventForm?.weekDaySelected.includes(option.value),
                    )}
                    sortType="custom"
                  />
                </div>
              )}
              {eventForm?.period === "month" && (
                <>
                  <div className="col-md-4 mt-4">
                    <SelectInput
                      options={monthFrequencySet}
                      name="monthFrequency"
                      id="monthFrequency"
                      label="Month Frequency"
                      handleChange={(e) => {
                        handleSelectBoxChanges(e, "monthFrequency");
                      }}
                      value={eventForm?.monthFrequency}
                    />
                  </div>

                  <div className="col-md-4 mt-4   ">
                    <MultiSelectDropdown
                      options={daySet}
                      displayValue="label"
                      handleChange={(e) =>
                        handleMonthDayChanges(e, "monthDaySelected")
                      }
                      placeholder="Choose Day(s)"
                      // required
                      label="Choose Day(s)"
                      errorMessage={errorMessage}
                      selectedValue={daySet?.filter((option) =>
                        eventForm?.monthDaySelected.includes(option.value),
                      )}
                      sortType="custom"
                    />
                  </div>
                </>
              )}
            </>
          )}
          <div className="col-md-4 mt-0">
            <RadioInput
              name="location"
              id="location"
              label="Mode of Event"
              options={locationType}
              selectedValue={eventForm?.location}
              handleChange={(e) => {
                handleChange(e);
              }}
              errorMessage={errorMessage}
            />
          </div>

          {(eventForm?.location === "virtual" ||
            eventForm?.location === "hybrid") && (
            <div className="col-md-4 mt-4">
              <TextInput
                name="url"
                id="url"
                label="URL"
                value={eventForm?.url}
                placeholder="Enter your Link"
                handleChange={(e) => handleChange(e)}
                required
                maxLength={1000}
                errorMessage={errorMessage}
              />
            </div>
          )}
          {(eventForm?.location === "virtual" ||
            eventForm?.location === "hybrid") && (
            <div className="col-md-4 mt-4">
              <>
                <TextInput
                  name="passcode"
                  id="passcode"
                  label="Passcode"
                  value={eventForm?.passcode}
                  placeholder="Enter your Passcode"
                  handleChange={(e) => handleChange(e)}
                  maxLength={100}
                  errorMessage={errorMessage}
                />
              </>
            </div>
          )}

          {(eventForm?.location === "physical" ||
            eventForm?.location === "hybrid") && (
            <div className="col-md-4 mt-0">
              <TextAreaInput
                label="Address"
                name="address"
                id="address"
                value={eventForm?.address}
                placeholder="Enter meeting location"
                handleChange={(e) => handleChange(e)}
                errorMessage={errorMessage}
                maxLength={250}
                required
              />
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <TextAreaInput
                name="description"
                id="description"
                label="Description"
                placeholder="Description"
                value={eventForm?.description}
                handleChange={(e) => {
                  handleChange(e);
                }}
                errorMessage={errorMessage}
                maxLength={2500}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center align-items-center gap-3 mt-3">
            <Button
              label={isEditMode ? "Update" : "Add"}
              status="primary"
              type="submit"
              disabled={isPending}
            />
            <Button
              label="Reset"
              status="reset"
              type="reset"
              onClick={(e) => {
                handleReset(e);
              }}
            />
          </div>
        </form>
      </div>
    </>
  );
}

export default AddOrEditPublicEvents;
